// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"1b2396a6","644":"454d3e5a"}[chunkId] + ".chunk.js";
};